import { css } from '@emotion/react';

export const description = css`
  max-width: 640px;
  margin-bottom: 32px;
  & > a {
    font-weight: 400;
  }
`;
